import { render, staticRenderFns } from "./CleaningGroups.vue?vue&type=template&id=4cf8e8c3&scoped=true"
import script from "./CleaningGroups.vue?vue&type=script&lang=js"
export * from "./CleaningGroups.vue?vue&type=script&lang=js"
import style0 from "./CleaningGroups.vue?vue&type=style&index=0&id=4cf8e8c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8e8c3",
  null
  
)

export default component.exports